<template>
  <div ref="el" class="pe-tooltip group relative" @mouseenter="mouseOver()" @mouseleave="mouseLeave()">
    <slot v-if="!icon" />
    <pe-icon v-else>info</pe-icon>
    <Transition
      enter-active-class="ease-out duration-150"
      enter-from-class="opacity-0 -translate-y-4"
      leave-active-class="ease-in duration-150"
      leave-to-class="opacity-0 -translate-y-4"
    >
      <div
        v-if="text && hover"
        ref="floatingEl"
        class="pe-tooltip--box top-0 group-hover:opacity-100"
        :style="{ ...floatingStyles, width: props?.width }"
        v-html="text"
      ></div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue'
import { useFloating, Placement, shift, offset, autoUpdate, flip } from '@floating-ui/vue'

const props = defineProps<{
  text?: string
  icon?: boolean
  delay?: number
  width?: string
  position?: Placement
}>()

const hover = ref(false)
let tm = null
const floatingEl = ref()
const el = ref()

const { floatingStyles } = useFloating(el, floatingEl, {
  placement: props.position || 'top',
  middleware: [offset(10), flip(), shift()],
  whileElementsMounted: autoUpdate,
})

const mouseOver = () => {
  if (tm) return
  tm = setTimeout(() => {
    hover.value = true
  }, props.delay || 400)
}

const mouseLeave = () => {
  hover.value = false
  clearTimeout(tm)
  nextTick(() => (tm = null))
}
</script>

<style lang="scss" scoped>
.pe-tooltip {
  @apply inline-block;

  .pe-tooltip--box {
    @apply absolute z-[9999] w-48 rounded-lg bg-neutral-900 bg-opacity-90 p-3 text-sm font-normal leading-5 text-white shadow-lg shadow-black/30 whitespace-pre-line ;
    // @apply opacity-0 transition-all;
  }
}
</style>
